module.exports = __webpack_public_path__ + "img/chevron_right.a731902c.svg";